/**
 * Сервис заказов
 * @module API/orders
 * */

import { order } from './fixtures/orders'

// import client from 'API/client'

// const PREFIX = 'shops/v1/'

/**
 * Получить список заказов
 * @function
 * @return {Promise}
 * */
export const getOrders = () => ({
  data: [
    order(),
    order(),
    order(),
    order(),
    order()
  ]
})
